module.exports = __webpack_public_path__ + "static/media/New MG Logo (Dark BG) (1).6786de9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/New MG Logo (Dark BG) (1).png
// module id = 1050
// module chunks = 0